import React from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import IconsWidgetSettings from "../WidgetsSettings/WebWidgets/IconsWidgetWeb/IconsWidgetWebSettingsModal";
import IntlMessages from "@util/IntlMessages";
import { Divider } from "../../BP2Components";

const IconsWidget = ({ value, role }) => {
   return (
      <Widget
         styleName="gx-m-0"
         bgColor={value.backgroundColourHex}
         title={value.tooltipTranslationKey}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetName={value.name}
                  widgetId={value.id}
                  icon="setting"
                  deleteIcon="true"
                  children={<IconsWidgetSettings value={value} />}
               />
            )
         }
      >
         {" "}
         <strong>
            <IntlMessages id="settings.tooltipTranslationKey" /> :
         </strong>{" "}
         {value.tooltipTranslationKey}
         <Divider />
         <strong>
            <IntlMessages id="settings.widgetKey" /> :
         </strong>{" "}
         {value.widgetKey}
         <Divider />
         <strong>
            {" "}
            <IntlMessages id="settings.icons" /> :
         </strong>
         <p>
            <ul>
               {value.icons.map((icon) => (
                  <li>{icon.icon}</li>
               ))}
            </ul>
         </p>
      </Widget>
   );
};

export default IconsWidget;
